import { render, staticRenderFns } from "./HandleMeasureTabGeneral.vue?vue&type=template&id=338f8506"
import script from "./HandleMeasureTabGeneral.vue?vue&type=script&lang=js"
export * from "./HandleMeasureTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./HandleMeasureTabGeneral.vue?vue&type=style&index=0&id=338f8506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports